<template>
  <body>
    <base-card>
      <div class="dots dots1"></div>
      <div class="dots dots2"></div>
      <h1 class="showcase-name">Mansur</h1>

      <!-- Main Content -->
      <main class="container">
        <div class="section-title">
          <h2 class="section-title__heading">Find Me</h2>
          <p class="section-title__subtitle">
            let's see what you are looking for...
          </p>
        </div>

        <div class="socials">
          <article class="social flex-center">
            <div class="social__title">
              <h2 class="section-heading">Mansur's coding</h2>
              <div class="social__icons">
                <a href="https://github.com/MansurIsakov" target="blank"
                  ><i class="fab fa-github"></i
                ></a>
                <a href="https://t.me/Untitled_project1" target="blank"
                  ><i class="fas fa-blog"></i
                ></a>
                <a
                  href="https://www.linkedin.com/in/mansur-isakov/"
                  target="blank"
                  ><i class="fab fa-linkedin"></i
                ></a>
              </div>
            </div>

            <div class="paragraph text">
              <p>
                For code snippets, projects, and some creative examples of
                mixing HTML, CSS and JavaScript, I would recommend to visit my
                <a
                  href="https://github.com/MansurIsakov"
                  target="blank"
                  class="link"
                  >GitHub Profile.</a
                >
                I also always share my newest big and little projects on my
                <a
                  href="https://t.me/Untitled_project1"
                  target="blank"
                  class="link"
                  >Blog.</a
                >
              </p>
              <p>
                For professional cooperation, visit my
                <a
                  href="https://www.linkedin.com/in/mansur-isakov/"
                  target="blank"
                  class="link"
                  >LinkedIn account.</a
                >
              </p>
            </div>
          </article>
          <article class="social flex-center">
            <div class="social__title">
              <h2 class="section-heading">Mansur's creative</h2>
              <div class="social__icons">
                <a href="https://t.me/logos_X" target="blank"
                  ><i class="fas fa-pencil-ruler"></i
                ></a>
                <a href="https://t.me/mansur_choice" target="blank"
                  ><i class="fas fa-music"></i
                ></a>
              </div>
            </div>

            <div class="paragraph text">
              <p>
                From time to time, I post on
                <a href="https://t.me/logos_X" target="blank" class="link"
                  >telegram channel.</a
                >
                There, I like to share my little design projects.
              </p>
              <p>
                Also, I recommend to check my
                <a href="https://t.me/mansur_choice" target="blank" class="link"
                  >music playlist.</a
                >
              </p>
            </div>
          </article>
          <article class="social flex-center">
            <div class="social__title">
              <h2 class="section-heading">Mansur's private life</h2>
              <div class="social__icons">
                <a
                  href="https://www.instagram.com/mansur_isakov_/"
                  target="blank"
                  ><i class="fab fa-instagram"></i
                ></a>
                <a href="https://t.me/MansurIsakov" target="blank"
                  ><i class="fab fa-telegram"></i
                ></a>
                <a
                  href="https://www.facebook.com/mansur.isakov.982"
                  target="blank"
                  ><i class="fab fa-facebook"></i
                ></a>
              </div>
            </div>

            <div class="paragraph text">
              <p>
                I regularly report from my journeys and sometimes from over my
                plate on
                <a
                  href="https://www.instagram.com/mansur_isakov_/"
                  target="blank"
                  class="link"
                  >Instagram.</a
                >
                To chat with me, use
                <a href="https://t.me/MansurIsakov" target="blank" class="link"
                  >Telegram.</a
                >
              </p>
              <p>
                If we met in real life, why not connect via
                <a
                  href="https://www.facebook.com/mansur.isakov.982"
                  target="blank"
                  class="link"
                  >facebook?</a
                >
              </p>
              <br />
            </div>
          </article>
        </div>
      </main>
      <!-- End Main Content -->
    </base-card>
  </body>
</template>

<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.bg {
  background-color: var(--tertiary-color);
}
.dots:before,
.dots:after {
  background-image: linear-gradient(var(--secondary-color) 20%, transparent 0);
}
h1 {
  background-color: var(--secondary-color);
}

// Section Title
.section-title {
  &__heading {
    color: var(--secondary-color);
  }
  &__subtitle {
    color: var(--primary-color);
  }
}
// End Section Title

// Content
.social {
  &:not(:last-child) {
    margin-bottom: 60px;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 50px;
  }
  &__icons {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      background-color: var(--secondary-color);
      color: var(--tertiary-color);
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      transition: add 0.2s ease-in;
      position: relative;
      overflow: hidden;
      text-decoration: none;
      z-index: 1;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--secondary-color);
        z-index: -2;
      }

      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        height: 100%;
        background-color: darken(#112d4e, 10%);
        transition: all 0.5s;
        z-index: -1;
      }
      &:hover {
        color: var(--secondary-color);
        transform: translateY(-1px);
        &:before {
          width: 100%;
        }
      }

      i {
        font-size: 26px;
        text-align: center;

        text-decoration: none;
        background-size: 205% 100%;
        background-position: 100% 0;
        padding: 0.5rem;
        transition: background-position 0.35s ease-in-out;
      }
    }

    a:not(:last-child) {
      margin-right: 20px;
    }
  }
  .section-heading {
    &:before,
    &:after {
      width: 30%;
    }

    &:before {
      margin-left: -35%;
    }

    &:after {
      margin-right: -35%;
    }
  }

  p {
    .link {
      border-bottom: 2px solid var(--primary-color);
      &:hover {
        background-color: var(--primary-color);
      }
    }
  }
}
// End Content

/* Adaptives */
@media only screen and (max-width: 64em) {
  // Content
  .social {
    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }
  // End Content
}
@media only screen and (max-width: 30em) {
  // Content
  .social {
    &__icons {
      a {
        width: 35px;
        height: 35px;
        margin-right: 10px;

        i {
          font-size: 23px;
          text-align: center;

          text-decoration: none;
          background-size: 205% 100%;
          background-position: 100% 0;
          padding: 0.5rem;
          transition: background-position 0.35s ease-in-out;
        }
      }

      a:not(:last-child) {
        margin-right: 10px;
      }
    }
    .section-heading {
      &:before,
      &:after {
        width: 30%;
      }

      &:before {
        margin-left: -35%;
      }

      &:after {
        margin-right: -35%;
      }
    }

    p {
      .link {
        border-bottom: 2px solid var(--primary-color);
        &:hover {
          background-color: var(--primary-color);
        }
      }
    }
  }
  // End Content
}
/* End Adaptives */
</style>
